import { render, staticRenderFns } from "./StudentsCardChart.vue?vue&type=template&id=0bcf99ba&"
import script from "./StudentsCardChart.vue?vue&type=script&lang=js&"
export * from "./StudentsCardChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports